import { render, staticRenderFns } from "./DetalleRetroalimentacion.vue?vue&type=template&id=0a72d5b7&scoped=true&"
import script from "./DetalleRetroalimentacion.vue?vue&type=script&lang=js&"
export * from "./DetalleRetroalimentacion.vue?vue&type=script&lang=js&"
import style0 from "./DetalleRetroalimentacion.vue?vue&type=style&index=0&id=0a72d5b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72d5b7",
  null
  
)

export default component.exports